<script>
import Button from 'primevue/button';
import Toolbar from 'primevue/toolbar';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Card from 'primevue/card';
import Utils from '../../common/Utils';
import Constants from '../../common/Constants';
import Dialog from 'primevue/dialog';
import FileUpload from 'primevue/fileupload';

import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import TankManagementService from '../../services/tank-management';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';

export default{
    props: [],
    components: { FileUpload },
    data(){
        return{
            uploadDisplay: true,
        }
    },
    mounted(){
        this.$store.dispatch('security/setNavbarTitle', 'TmTankVolumetricData.page_title');
    },
    computed: {
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        }
    },
    methods: {
        uploaderResponseMethod(file){
            let formData = new FormData();
            formData.append('formFile', file.files[0]);
         
            this.$store.dispatch("generic/setLoading", true);
            
            TankManagementService.uploadExcelVolumetricData(formData, response => {
                if(response.success){
                    this.$store.dispatch("generic/setLoading", false);
                    this.$toast.add({detail: this.$t('tankManagement.toastUploadSuccesMessage'), life:3000, severity:'success'});
                 }else{
                    this.$store.dispatch("generic/setLoading", false);
                    this.$toast.add({detail: "Error: " + response.message, life:3000, severity:'error'});
                }
            })
        }
    },
}

</script>

<style>
.table-container{
    display: flex; 
    align-items: center; 
}
.resize-button-tool{
    height: 37px;
}
hr{
    border-top: 1px solid lightgrey;
}
.bold{
    font-weight: bold;
}

</style>

<template>
    <main>
        <div class="grid">
            <div class="col-8">
                <h3>{{$t('tankManagement.uploadHeader')}}</h3>
                <FileUpload name="uploaded[]" :customUpload="true" @uploader="uploaderResponseMethod" :previewWidth="0" :fileLimit="1" :multiple="false" />
            </div>                                           
        </div>
    </main>
</template>
        